<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="{
        slots: {
          buttons: 'toolbar_form',
        },
      }"
      :columns="tableColumns"
      :loading="loading"
      :height="300"
      size="small"
      resizable
      border
      show-footer
      :footer-method="() => footerData"
      :header-cell-style="
        () => {
          return {
            backgroundColor: '#bd94c1',
            color: '#ffffff',
          }
        }
      "
    >
      <template v-slot:toolbar_form>
        <div class="side-frame-success">
          <span style="font-size: 14px; color: #606266">
            {{ $l('INDEX.form_label_goods') || '产品信息' }}
          </span>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: { orderProofingCode: { type: String, default: '' } },
  data() {
    return {
      loading: false,
      tableData: [],
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      let goosQty = 0
      this.tableData.forEach((item) => {
        goosQty += parseInt(item['goosQty'])
      })
      return [['合计', '', goosQty || 0, '']]
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.orderProofingCode) return
      this.loading = true
      this.$api
        .pendingOrderProofingGoodsListApi({
          orderProofingCode: this.orderProofingCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
